import { useState } from "react";
import SideBar from "../../components/sidebar.tsx/SideBar";
import { Typography } from "@material-tailwind/react";
import Account from "./Account";
import Administrator from "./administrator/Administrator";

function Settings() {
  const [activeTab, setActiveTab] = useState("account-settings");

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div className="md:flex">
      <div className="bg-gray-100 h-full ">
        <SideBar />
      </div>
      <div className="flex-1 p-8">
        <Typography placeholder={undefined}  className="text-2xl font-normal">Settings</Typography>
        <div className="">
          <nav className="flex space-x-2 py-2" aria-label="Tabs" role="tablist">
            {["account-settings", "administrator"].map((tab) => (
              <button
                key={tab}
                type="button"
                className={`py-2 px-1 inline-flex items-center gap-x-2   whitespace-nowrap text-gray-500  focus:outline-none disabled:opacity-50 disabled:pointer-events-none ${
                  activeTab === tab
                    ? "text-red-500 border-b border-red-600"
                    : ""
                }`}
                id={`tabs-with-underline-item-${tab}`}
                data-hs-tab={`#tabs-with-underline-${tab}`}
                aria-controls={`tabs-with-underline-${tab}`}
                role="tab"
                onClick={() => handleTabClick(tab)}
              >
                {tab === "account-settings"
                  ? "Account Settings"
                  : "Administrator"}
              </button>
            ))}
          </nav>

          <div className="mt-3">
            {["account-settings", "administrator"].map((tab) => (
              <div
                key={tab}
                id={`tabs-with-underline-${tab}`}
                role="tabpanel"
                aria-labelledby={`tabs-with-underline-item-${tab}`}
                className={`${activeTab === tab ? "" : "hidden"}`}
              >
                <div className="font-semibold text-gray-800 ">
                  {tab === "account-settings" ? <Account /> : <Administrator />}{" "}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
